import { APIError } from './errors/api_error';
export async function getCompanyRegistration({ companyCode, globalDomain, }) {
    const globalApiUrl = `https://global-api.${globalDomain}/v1`;
    const response = await fetch(`${globalApiUrl}/company-registrations/${companyCode}`);
    if (!response.ok) {
        throw new APIError(`Could not fetch company registration for companyCode: '${companyCode}', status: '${response.status}'`, response);
    }
    try {
        const data = (await response.json());
        return {
            companyRegistration: {
                companyCode: data.company_registration.company_code,
                regionCode: data.company_registration.region_code,
                companyName: data.company_registration.company_name,
                companyLogoUrl: data.company_registration.company_logo_url,
                switchWorkspacesEnabled: data.company_registration.switch_workspaces_enabled,
            },
            apiUrl: removeTrailingForwardSlash(data.api_url),
            loggingUrl: data.logging_url,
            wallUrl: data.wall_url,
        };
    }
    catch (error) {
        throw new APIError(`Error getting company registration for companyCode: '${companyCode}'`, response);
    }
}
export function removeTrailingForwardSlash(apiUrl) {
    return apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
}
//# sourceMappingURL=get_company_registration.js.map